import {AbDataSheetElement} from "@/scripts/components/ab-data-sheet/abDataSheet.element";
import {createDomElementHandler} from "@/scripts/utils/dom.utils";
import {AbModal} from "@/scripts/modules/ab-modal/ab-modal.class";
import {AbDataSheetModalOptions, AbDataSheetUpdateEvDetail} from "@/scripts/components/ab-data-sheet/ab-data-sheet.types";
import {ProductTypeEnum} from "@shared/enums";
import {AbModalConfigInterface, AbModalSizingClassesEnum} from "@/scripts/modules/ab-modal/ab-modal.types";

export class AbDataSheetInModalClass {

  private modalConfig: AbModalConfigInterface = {
    autoOpen: false,
    handleBackBrowser: true,
    hideBodyOverflow: true,
    id: '',
    attributes: {
      classesWrapper: '',
      classesModal: 'ab-modal--lg',
      classesBackdrop: 'ab-modal__backdrop--light-75',
      classesInner: '',
      header: {
        show: true,
        classes: '',
        text: " ",
        closeButtonText: 'chiudi',
        closeButton: true,
      },
    }
  }

  constructor(options: AbDataSheetModalOptions) {

    const { productIds, autoOpen = false, purchaseScopes } = options;
      const title = productIds.split(',').length === 1 ?
      `Scheda Tecnica` :
      `Confronto Prodotti`;

    this.modalConfig.id = title;
    this.modalConfig.attributes.header.text = title;
    const attrs = {productIds, sticky: 'true', autoOpen: autoOpen ? 'true' : 'false'};
    const dataSheetEl: AbDataSheetElement = createDomElementHandler('ab-data-sheet', [], attrs) as AbDataSheetElement;
    dataSheetEl.purchaseScopes = purchaseScopes;
    const modal = new AbModal(this.modalConfig, dataSheetEl);
    modal.show();

    dataSheetEl.addEventListener("ab-data-sheet-updated", ( event: Event) => {
      const separator = "&middot;";
      const products = (event as CustomEvent<AbDataSheetUpdateEvDetail>).detail.products;
      const productNames = products.map(({name}) =>  name);

      const productTypeName = products.at(0).type === ProductTypeEnum.OBIETTIVO ?
        'Obiettivi' :
        'Fotocamere';

      let modalSizingClass = AbModalSizingClassesEnum.MEDIUM;
      if (products.length > 3) {
        modalSizingClass = AbModalSizingClassesEnum.FULL;
      } else if (products.length > 1) {
        modalSizingClass = AbModalSizingClassesEnum.LARGE;
      }
      modal.updateSizing(modalSizingClass);

      const newModalTitle = productNames.length === 1 ?
        "Scheda Tecnica " + productNames[0] :
        `Confronto ${productTypeName}: ${productNames.join(` ${separator} `)}`;

      modal.updateTitle(newModalTitle);
    });

  }
}
